import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import React from "react";

interface ConfirmationDialogProps {
  isOpen: boolean;
  text: string;
  noBtnClick: () => void;
  yesBtnClick: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  text,
  noBtnClick,
  yesBtnClick,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={noBtnClick}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          borderRadius: "8px",
          border: "1px solid rgba(96, 119, 131, 0.5)",
          boxShadow: "0px 20px 20px rgba(0, 0, 0, 0.25)",
          padding: "20px",
          zIndex: 1700, // 👈 ensures it stays above other dialogs
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: 16, textAlign: "center" }}>
        Bestätigung
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center" fontSize={14}>
          {text}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
        <Button
          onClick={noBtnClick}
          sx={{
            border: "2px solid #DE3730",
            color: "#DE3730",
            borderRadius: "4px",
            fontWeight: 600,
            "&:hover": { backgroundColor: "rgba(222, 55, 48, 0.1)" },
          }}
        >
          Nein
        </Button>
        <Button
          onClick={yesBtnClick}
          sx={{
            backgroundColor: "var(--green)",
            color: "white",
            borderRadius: "4px",
            fontWeight: 600,
            "&:hover": { backgroundColor: "darkgreen" },
          }}
        >
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
